import React from 'react';
import PendingEduEmailField from './PendingEduEmailField';

export default function EduProfileVerificationPopup({
  open,
  onClose,
  pending,
  submitted,
  emailConfirmed = false,
  sendFailed = false,
  submittedEmail = '',
  emailInput,
  onEmailInputChange,
  emailError,
  submitting,
  onSubmit,
  onResend,
  resendCooldownSeconds = 0,
}) {
  if (!open) return null;

  const showConfirmEmail = submitted || (pending && !emailConfirmed);

  return (
    <div
      className="cart-popup-overlay cart-popup-overlay--above-feed-detail"
      onClick={onClose}
    >
      <div className="cart-popup berkeley-email-popup" onClick={(e) => e.stopPropagation()}>
        <button className="cart-popup-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        {showConfirmEmail ? (
          <>
            <h3 className="cart-popup-title">CONFIRM YOUR EMAIL</h3>
            {sendFailed ? (
              <p className="cart-popup-message berkeley-email-error" style={{ margin: '0.75rem 0 0' }}>
                We couldn&apos;t deliver the verification link to this address. Tap RESEND to try again.
              </p>
            ) : (
              <p className="cart-popup-message" style={{ margin: '0.75rem 0 0' }}>
                We sent a link to verify your .edu email. Confirm your email.
              </p>
            )}
            <p className="cart-popup-message" style={{ margin: '0.65rem 0 1.5rem' }}>
              We use your .edu email as a reliable way to verify you are a real person before you get matched.
            </p>
            <PendingEduEmailField
              email={submittedEmail}
              cooldownSeconds={resendCooldownSeconds}
              busy={submitting}
              error={emailError}
              onSave={onSubmit}
              onResend={onResend}
              variant="popup"
            />
          </>
        ) : pending ? (
          <>
            <h3 className="cart-popup-title">VERIFICATION PENDING</h3>
            <p className="cart-popup-message" style={{ margin: '0.75rem 0 1.5rem' }}>
              Your .edu email is confirmed and your profile is being verified. This can take up to 24 hours. We only match real people.
            </p>
            <button type="button" className="berkeley-email-got-it" onClick={onClose}>
              Got it
            </button>
          </>
        ) : (
          <>
            <h3 className="cart-popup-title">VERIFY YOUR PROFILE</h3>
            <p className="cart-popup-message" style={{ margin: '0.75rem 0 1.25rem' }}>
              You need a verified .edu email to reach out. If you have one, please enter it here for verification:
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <input
                type="email"
                className="berkeley-email-input"
                placeholder="you@school.edu"
                value={emailInput}
                onChange={(e) => onEmailInputChange(e.target.value)}
                autoFocus
                disabled={submitting}
              />
              {emailError ? <p className="berkeley-email-error">{emailError}</p> : null}
              <div className="post-confirm-actions">
                <button type="button" className="post-confirm-cancel" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="post-confirm-confirm" disabled={submitting}>
                  {submitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
